import { call, put, takeLatest } from 'redux-saga/effects';

import getDivisionVacanciesInfoAPI from '../../api/get-division-vacancies-info';
import getVacanciesAPI from '../../api/get-vacancies';
import {
  receiveDivisionVacanciesInfo,
  receiveVacancies,
  rejectDivisionVacanciesInfo,
  rejectVacancies,
  requestDivisionVacanciesInfo,
  requestVacancies,
} from '../actions/admin-page';

interface IGetVacanciesAction {
  type: string;
  payload: {
    division?: string;
    search?: string;
    group?: string;
    grade?: string;
    status?: string;
    responsible?: string;
    showOnlyMyVacancies?: boolean;
    showPrivateVacancies?: boolean;
  };
}

interface IGetDivisionVacanciesInfoAction {
  type: string;
  payload: {
    division: string;
  };
}

type VacanciesResponse = ReturnType<typeof getVacanciesAPI>
type DivisionVacanciesInfoResponse = ReturnType<typeof getDivisionVacanciesInfoAPI>

const getVacancies = function* getVacancies(action: IGetVacanciesAction) {
  try {
    const response: VacanciesResponse = yield call(
      getVacanciesAPI,
      action.payload,
    );
    yield put(receiveVacancies({ data: response }));
  } catch (error) {
    yield put(rejectVacancies({ error }));
  }
};

const getDivisionVacanciesInfo = function* getDivisionVacanciesInfo(
  action: IGetDivisionVacanciesInfoAction,
) {
  try {
    const response: DivisionVacanciesInfoResponse = yield call(getDivisionVacanciesInfoAPI, action.payload.division);
    yield put(receiveDivisionVacanciesInfo({ data: response }));
  } catch (error) {
    yield put(rejectDivisionVacanciesInfo({ error }));
  }
};

export default function* vacanciesWatcher() {
  yield takeLatest(requestVacancies, getVacancies);
  yield takeLatest(requestDivisionVacanciesInfo, getDivisionVacanciesInfo);
}
